import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ChatAvatarComponent } from './chat-avatar/chat-avatar.component';
import { ChatWidgetComponent } from './chat-widget/chat-widget.component';
import { ChatInputComponent } from './chat-input/chat-input.component';
import { ChatConfigComponent } from './chat-config/chat-config.component';
import { ChatService } from './chatbot-rasa.service';
import { SanitizePipe } from './sanitize.pipe';
import {SharedModule} from "../../shared/shared.module";

@NgModule({
    imports: [CommonModule, BrowserAnimationsModule, SharedModule],
  declarations: [ChatAvatarComponent, ChatWidgetComponent, ChatInputComponent, ChatConfigComponent, SanitizePipe],
  exports: [ChatWidgetComponent, ChatConfigComponent],
  entryComponents: [ChatWidgetComponent, ChatConfigComponent],
  providers: [ChatService]
})
export class ChatbotRasaModule { }
